import {Button, Dropdown, Empty, Input, List, Modal, Popover, Space, Spin,message,Tooltip} from 'antd';
import Note from '@/views/Note/NoteItem/NoteItemIndex'
import style from './index.module.less'
import Icon, {CheckOutlined, DownOutlined, FolderOutlined, MoreOutlined, SearchOutlined} from '@ant-design/icons';
import {useLocation} from 'react-use';
import {ipcInvoke, ipcOn, ipcSend} from '@/common/ipc';
import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useLayoutEffect, useRef, useState} from 'react';
import {
    createEmptyProject,
    extFromMineType,
    generateRandomPageKey,
    generateUUID2,
    getFileNameWithoutExt, getImagePath,
    getImagePathSvg,
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    getIntValue,
    getItem,
    hasBeyondFreeLimit,
    hasDesktopBaseLicense,
    hasLicense,
    imgPathPerfix,
    isBase64,
    isDarkMode,
    isFreeCreateCardMode,
    isInSidebar,
    isShortcuts,
    isStringNullOrEmpty,
    isSvg,
    removeHtmlTags,
    templatePathPerfix
} from "@/utils";
import CodeInlie from '@tiptap/extension-code'
import emitter, {
    BUTTON_PADDING,
    DEFAULT_DATE_FORMAT,
    DESKTOP_PRO_FROM_IMPORT_BACKUP_FILE, EVENT_FAVIRIATE_CHANGE,
    EVENT_FORCE_UPDATE,
    EVENT_MOVE_FOLDER,
    EVENT_NEW_PROJECT,
    EVENT_NOTE_CHANGED,
    EVENT_OPEN_OUT_APP_DATA, EVENT_REFRESH_FAVOR, EVENT_REFRESH_LIBRARY_TAG_LIST,
    EVENT_REFRESH_LOGIN_STATUS, EVENT_REFRESH_RECENTS,
    EVENT_RESET_SEARCH,
    EVENT_SELECTED_FOLDER,
    EVENT_SHOW_DESKTOP_PRO_VIP,
    EVENT_SHOW_MESSAGE_BOX,
    EVENT_SHOW_TEMPLATE_DIALOG,
    EVENT_SWITCH_HOME_LIST_MENU,
    EVENT_UPDATE_FOLDER_NAME,
    EVENT_UPDATE_NOTE,
    FILTER_TAG_NO_TAGS,
    FROM_DIALOG,
    FROM_HOME, FROM_LIBRARY,
    FROM_RIGHT_SIDE,
    FROM_TAG,
    FROM_TRASH,
    HEADER_HEIGHT, KEY_FILTER_SELECT_TAG,
    KEY_MACHINEID,
    KEY_NEW_PROJECT_ID,
    KEY_PROJECT_THUMB_INDEX, KEY_SHOW_HIDIN_CARDS, KEY_SHOW_HIDIN_PROJECTS,
    MAX_CARD_COUNT, MENU_SEPARATOR, PAGE_SIZE,
    POST_MESSAGE_REFRESH_FOLDER_LIST,
    RESPONSE_LAYOUT_L1,
    RESPONSE_LAYOUT_L2,
    SYS_CONFIG_KEY_DATEFORMAT,
    SYS_CONFIG_KEY_ORDER_BY,
    SYS_CONFIG_KEY_SORT_TYPE,
    SYS_CONFIG_KEY_VIEW_STYLE,
    VIEW_STYLE, WIDTH_3, WIDTH_4, WIDTH_5
} from "@/Const";
import {getSysConfig, updateSysConfig} from "@model/sysconfig";
import {
    batchUpdateProject,
    delNote,
    getNoteList,
    getNoteListCount, getProjectById, getPublishProjectList,
    getSearchNoteList,
    staticFolderNoteCount,
    updateNote, updateProject
} from "@model/note";
import {postMessage, recvMessage, unSubscribe, unSubscribeAll} from "@/common/event";
import Global from '@/global'
import {useTranslation} from "react-i18next";
import DialogNewProject from "@/views/Home/DialogNewProject";
import DialogTemplate from "@/views/Home/DialogTemplate";
import DialogNewFolder from "@/views/Home/DialogNewFolder";
import {allFolder, deleteFolder, getFolderById} from "@model/folder";
import {
    IconClose,
    IconDelete,
    IconHomeSearch,
    IconIndicatorBlue, IconMenuChecked1,
    IconNewProject,
    IconRename, IconTransparent
} from "@/Icon";
import "./CanvasListIndex.css"
import DialogMovetoFolder from "@/views/Home/DialogMovetoFolder";
import DialogImport from "@/views/Home/DialogImport";
import DialogMessageBox from "@/common/DialogMessageBox";
import {APP_WEB, APP_WEB_WWW, isWeb, isWebApp} from "@/electron_interactive";
import DialogExportTips from "@/views/Draw/DialogExportTips";
import {openEditor} from "@/state";
import {getCardCount, updateCard} from "@model/card";
import DialogTagManager from "@/views/Dialog/DialogTagManager";
import {imgServer} from "@/components/EditorV2/imgServer";
import {useEditor} from "@tiptap/react";
import global from "@/global";
import HomeNavigator from "@/views/Home/HomeNavigator";
import {getCardPath, getDrawPath, getSearchWidth} from "@/Utility";
import DialogChooseThumb from "@/views/Home/DialogChooseThumb";
import {isZh} from "@/language";
import { Node, Slice, Fragment } from "prosemirror-model";
import {getTagList} from "@model/tag";
import {handleImportMarkdown, processZipImport} from "@/components/EditorV2/MarkdownHandle";
import {getTiptapExtension} from "@/components/EditorV2/TiptapTiptapExtension";
import ProjectTab from "@/views/Home/views/CanvasListIndex/ProjectTab";
import {atomSliderWidth} from "@/App";
import {atom, useAtom} from "jotai";
import {KEYS} from "../../../../../@excalidraw/packages/excalidraw/keys";


let mFolderId:string = '';
//创建项目使用的id.... 在文件夹上更多创建
let mCreateProjectFolderId:string = '';
let mSearchKey = '';
let isFirstShow = true;
let mViewStyle:any = VIEW_STYLE.VIEW_STYLE_GRID;
let mSortTypeDesc = "Last viewed";
let mQueryTimes = 0;
let mArrayTags:any = [];

// 是否需要(允许)处理鼠标的移动事件,默认识不处理
var select = false;
// 定义移动元素div
var rect:any = null;
// 记录鼠标按下时的坐标
var downX = 0;
var downY = 0;
// 记录鼠标抬起时候的坐标
var mouseX2=downX;
var mouseY2=downY;
var mMouseDownTime:any = 0;
let mHandleTime = 0;

export const atomActiveProjectTab = atom<any>(null);

const HomeIndex = forwardRef((props:{from?:any,onCallback?:any}, ref) => {
    useImperativeHandle(ref, () => ({
        updateNoteList: updateNoteListPub,
        onResizeEvent: onResizeEvent,
        onSearch: onSearch
    }))
    const {t} = useTranslation();
    // const navigate = useNavigate();
    const dialogNewProjectRef = useRef(null);
    const dialogTemplateRef = useRef(null);
    const dialogNewFolderRef = useRef(null);
    const dialogMovetoFolderRef = useRef(null);
    const dialogImportRef = useRef(null);
    const dialogMessageBoxRef = useRef(null);
    const dialogTagManagerRef = useRef(null);
    const dialogChooseThumbRef = useRef(null);
    const mThisID = useRef<any>(crypto.randomUUID());

    const locationParams = useLocation();

    getSysConfig(SYS_CONFIG_KEY_VIEW_STYLE).then((res) => {
        if (res != undefined) {
            mViewStyle = res?.value;
            setViewStyle(mViewStyle)
        }
    });
    const [isShowEmptyData, setIsShowEmptyData] = useState(false);
    const [sortMenuOpen, setSortMenuOpen] = useState(false);
    const [isTagFilterOpened, setIsTagFilterOpened] = useState(false);
    const [viewStyle, setViewStyle] = useState<VIEW_STYLE>(mViewStyle);
    const [sortTypeDesc, setSortTypeDesc] = useState(mSortTypeDesc);
    const [noteList, setNoteList] = useState([]);
    const [noteSearchList, setNoteSearchList] = useState([]);
    const [noteSearchListCount, setNoteSearchListCount] = useState(1);//默认不显示。。。。。
    const [folderName, setFolderName] = useState(t("Projects"));
    const [arrayFolders, setArrayFolders] = useState([]);
    const [isNoteListVisible, setIsNoteListVisible] = useState(true);
    const [searchKey, setSearchKey] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const [isNewProjectHover, setIsNewProjectHover] = useState(false);
    const [isNewCardHover, setIsNewCardHover] = useState(false);
    const [isImportHover, setIsImportHover] = useState(false);
    const [isLoadingNoteList, setIsLoadingNoteList] = useState(false);
    const [isOpenPopoverImport, setIsOpenPopoverImport] = useState(false);
    const [progress, setProgress] = useState(0);
    const [messageApi, contextHolder] = message.useMessage();
    const [noteItemWidth, setNoteItemWidth] = useState('270px');
    const [columnTemplate, setColumnTemplate] = useState('repeat(4,1fr)');
    const [rightSliderWidth, setRightSliderWidth] = useAtom(atomSliderWidth);
    const [activeTabItem,setActiveTabItem] = useState(null);
    const [sortMenu, setSortMenu] = useState([
        {
            key: "sort by",
            type: 'group',
            label: t('Sort by'),
            children: [
                {
                    key: 'sort by name',
                    label: t("alphabetical"),
                    icon: <CheckOutlined style={{color: 'white', fontSize: '0px'}}/>
                },
                {
                    key: 'sort by createDate',
                    label: t('Date created')
                },
                {
                    key: 'sort by updateDate',
                    label: t('Last viewed')
                }
            ]
        },
        {
            key: "order",
            type: 'group',
            label: t('Order'),
            children: [
                {
                    key: 'date asc',
                    label: t('Oldest first')
                },
                {
                    key: 'date desc',
                    label: t('Newest first')
                }
            ]
        }
    ])
    const [arrayTags, setArrayTags] = useState<any>([]);
    const [selectTag, setSelectTag] = useState(null);
    const [projectCount,setProjectCount] = useState(0);

    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    //文件夹MORE

    const [itemSize, setItemSize] = useState(null);
    const mSelectTag = useRef<any>(null);
    const mPageNum = useRef(0);//分页
    let mArrayNoteListCache = useRef<any>([]);
    const mSearchTimeout = useRef<any>(0);
    const mActiveTabItemRef = useRef<any>(null);
    const mProjectTabRef = useRef(null);
    const [isShowHiddenProjects,setIsShowHiddenProjects] = useState(localStorage.getItem(KEY_SHOW_HIDIN_PROJECTS) == 'true');
    const [isShowChecked,setIsShowChecked] = useState(false);
    const [showCheckedTitle,setShowCheckedTitle] = useState('');
    const mMapIdCheckRef = useRef<any>({});
    const mManagerTagsPageNum = useRef(0);//保留多选管理标签返回刷新时候的pageNum
    //标识查询
    const isQuerying = useRef(false);

    const ARRAY_FOLDER_MORE = [
        {
            icon: <IconNewProject/>,
            key: 'newProject',
            label: t("New project")
        },
        {
            icon: <IconRename/>,
            key: 'rename',
            label: t("Rename")
        },
        {
            icon: <IconDelete/>,
            key: 'delete',
            label: t("Delete")
        }
    ]

    /**
     * 更多菜单
     */
    const getLibraryMoreMenu = () => {
        return [
            getItem(<div style={{minWidth:'160px'}}>{t("ShowAllHiddenProjects")}</div>, 'showAllProjects', (localStorage.getItem(KEY_SHOW_HIDIN_PROJECTS) == 'true') ?
                <IconMenuChecked1/> : null, undefined, undefined, () => {
                let isShowHiddenProject = localStorage.getItem(KEY_SHOW_HIDIN_PROJECTS) == 'true';
                localStorage.setItem(KEY_SHOW_HIDIN_PROJECTS,isShowHiddenProject?'false':'true');
                setIsShowHiddenProjects(!isShowHiddenProject);
                //如果不是在all,要转到all.
                if (mActiveTabItemRef.current?.id != 'all'){
                    mProjectTabRef.current?.onSetActiveTableId('all');
                }else{
                    refreshProjectList();
                }
            }),
        ]
    }

    useEffect(() => {
        //慢慢慢....
        if (!isWeb()) {
            setTimeout(() => {
                ipcInvoke("check-args", {}).then(args => {
                    if (args != undefined && args.hasOwnProperty("data")) {
                        onImportNote(args.data, args.filePath);
                    }
                })
            }, 500);

            // ipcOn("message",(event,args)=>{
            //     console.log(args);
            //     if (args.hasOwnProperty("action") && args['action'] == 'outOpenApp'){
            //         let szArgs = args["obj"];
            //         if(szArgs.endsWith(".pcanvas") || szArgs.endsWith(".pcanvasx")){
            //             //打开文件？
            //             ipcInvoke("check-args",{filePath:szArgs}).then(args=>{
            //                 if (args != undefined && args.hasOwnProperty("data")){
            //                     onImportNote(args.data,args.filePath);
            //                 }
            //             })
            //         }
            //     }
            // })
            //打开外部数据....
            // if (global.g_openOutData){
            //     onImportNote(global.g_openOutData.data,global.g_openOutData.filePath);
            //     global.g_openOutData = null;
            // }
        }

        unSubscribeAll();

        recvMessage(EVENT_RESET_SEARCH, (msg, data) => {
            setSearchKey('');
        })


        recvMessage(EVENT_UPDATE_FOLDER_NAME, (msg, data) => {
            if (mFolderId === data.data.id) {
                setFolderName(data.data.name);
            }
        }, true);

        recvMessage(EVENT_MOVE_FOLDER, (msg, data) => {
            if (mFolderId == '-2') {
                //在文件夹列表...
                initFolderInfo();
            }
        })

        recvMessage(EVENT_NEW_PROJECT, async (msg, data) => {
            if (await hasBeyondFreeLimit()) {
                postMessage(EVENT_SHOW_DESKTOP_PRO_VIP, {from: ''})
                return;
            }

            mCreateProjectFolderId = data.data.id;
            // dialogNewProjectRef?.current.showNewProjectDialog();
            window.navigateOrigin(getDrawPath(), {state: {folderId: mCreateProjectFolderId}})
        }, true);

        recvMessage(EVENT_SHOW_TEMPLATE_DIALOG, (msg, data) => {
            dialogTemplateRef?.current?.onShowDialog();
        }, true);

        recvMessage(EVENT_SHOW_MESSAGE_BOX, (msg, data) => {
            dialogMessageBoxRef?.current?.onShowDialog(t("Confirm delete"), t("Delete note can view trash"), t("Delete"), () => {
                delNote(data.data);
            })
        })

        //主题刷新
        // recvMessage(EVENT_FORCE_UPDATE,(msg,data)=>{
        //     forceUpdate();
        // })

        //保存笔记............
        recvMessage(EVENT_UPDATE_NOTE, async (msg: any, data: any) => {
            const card = data.data.data;
            const isEmptyTitle = isStringNullOrEmpty(card.name) || card.name.toLowerCase() == t("Untitled").toLowerCase();
            if (isStringNullOrEmpty(removeHtmlTags(card.doc)) && isEmptyTitle && card.doc.indexOf('<img') == -1) {
                return;
            }

            card.type = card.type || 'card';
            updateCard(card, true, true, 'fromCanvasListIndex-EVENT_UPDATE_NOTE').then((res) => {
                if (!data.data.isAutoSave) {
                    window.onShowMessageTip(t("Card saved"), () => {
                        postMessage(EVENT_SWITCH_HOME_LIST_MENU, {name: 'library'})
                    })
                }
            });
        });

        //接收打开外部pcanvas的消息
        recvMessage(EVENT_OPEN_OUT_APP_DATA, (msg, data) => {
            onImportNote(global.g_openOutData.data, global.g_openOutData.filePath);
            global.g_openOutData = null;
        })

        //初始列表
        initData()
        //初始排序选中状态
        updateSortStates();
        resizeWindow();

        const resizeObserver = new ResizeObserver(entries => {
            if (props.from != FROM_RIGHT_SIDE){
                const divContainer = document.getElementById('divList');
                if (divContainer){
                    onResizeEvent(divContainer.clientWidth);
                }
            }
        })
        const divContainer = document.getElementById('divList');
        if (divContainer){
            resizeObserver.observe(divContainer);
        }

        if (props.from == FROM_RIGHT_SIDE){
            refreshProjectList();
        }

        //test....
        ipcInvoke('force-gc')?.then(res => {
            console.log('gc....', res);
        })
        if (window.gc) {
            window.gc();
            console.log('window.gc');
        }

        window.refreshList['updateTheme_canvasListIndex'] = forceUpdate;

        return () => {
            unSubscribe(EVENT_RESET_SEARCH);
            unSubscribe(EVENT_UPDATE_FOLDER_NAME);
            unSubscribe(EVENT_NEW_PROJECT);
            unSubscribe(EVENT_SHOW_TEMPLATE_DIALOG);
            unSubscribe(EVENT_SHOW_MESSAGE_BOX);
            // unSubscribe(EVENT_FORCE_UPDATE);
            unSubscribe(EVENT_MOVE_FOLDER);
            unSubscribe(EVENT_UPDATE_NOTE);
            unSubscribe(EVENT_OPEN_OUT_APP_DATA);
            delete window.refreshList['updateTheme_canvasListIndex'];
        }

    }, [])

    useEffect(() => {
        recvMessage(EVENT_NOTE_CHANGED, (msg, data) => {
            mPageNum.current = 0;
            updateNoteList();
        })
        recvMessage(EVENT_REFRESH_LIBRARY_TAG_LIST, (msg, data) => {
            updateTagList();
        })

        document.body.addEventListener('keydown', onKeyDown);
        window.addEventListener("resize", resizeWindow);
        document.body.addEventListener('mouseup',onDocumentMouseUp);
        window.refreshList['refreshProjectSingle_' + mThisID.current] = refreshSingleProjectItem;
        window['refresh_project_list'] = refreshProjectList;
        window['refresh_project_list_in_favor'] = refreshProjectListInFavor;
        window.refreshList['remove_project_by_id'] = removeProjectById;
        window.refreshList['remove_project_by_id_in_favor'] = removeProjectInFavorById;


        return () => {
            document.body.removeEventListener('keydown', onKeyDown)
            window.removeEventListener('resize', resizeWindow);
            document.body.removeEventListener('mouseup',onDocumentMouseUp);
            unSubscribe(EVENT_NOTE_CHANGED);
            unSubscribe(EVENT_REFRESH_LIBRARY_TAG_LIST);
            delete window.refreshList['refreshProjectSingle_' + mThisID.current];
            delete window['refresh_project_list'];
            delete window.refreshList['remove_project_by_id'];
        }
    })

    useEffect(() => {
        if (progress > 0 && progress < 100) {
            messageApi.open({
                type: 'loading',
                content: `Importing ${progress}%`,
                key,
                duration: 0,
            });
        } else if (progress >= 100) {
            messageApi.success({
                content: 'Import Complete',
                key,
                duration: 2,
            });
        }
    }, [progress]);

    useEffect(() => {
        mActiveTabItemRef.current = activeTabItem;
    }, [activeTabItem]);

    useEffect(() => {
        if (!global.g_isAutoRestore) {
            if (isLoadingNoteList) {
                window.showIndicator();
            } else {
                window.closeIndicator();
            }
        }
    }, [isLoadingNoteList])

    function onKeyDown(event: any) {
        // debugLog('keydown',event);

        if (window.location.href.includes('/home/project')) {
            if (event.target?.type != 'text' &&
                event.target?.type != 'textarea') {
                if (isShortcuts(event, 'newCard')) {
                    Global.g_currentNoteData = {id: generateRandomPageKey()}
                    openEditor(Global.g_currentNoteData.id, false, false);
                }
            }
        }
        if (event.key == KEYS.ESCAPE){
            if (isShowChecked){
                onExitChecked();
            }
        }
    }

    //region 多选
    //鼠标多选，点击
    function onDocumentMouseUp(e:any){
        onMouseUp(e);
    }

    const onMouseDown = (event:any)=>{
        if (props.from == FROM_RIGHT_SIDE)return;//仅首页的允许多选
        if (event.button == 2)return;//右键不多选
        // 鼠标按下时才允许处理鼠标的移动事件
        select = true;
        mMouseDownTime = new Date().getTime();
        const divProjectContainer:any = document.getElementById('div-project-list-container');

        if (rect) {
            divProjectContainer?.removeChild(rect);
        }

        rect = document.createElement("div");
        // 框选div 样式
        rect.style.cssText = "position:absolute;width:0px;height:0px;font-size:0px;margin:0px;padding:0px;border:1px dashed #0099FF;background-color:#C3D5ED;z-index:1000;filter:alpha(opacity:60);opacity:0.6;display:none;";
        rect.id = "selectDiv";
        rect.style.pointerEvents = 'none';
        // 添加到lay1下
        divProjectContainer?.appendChild(rect);

        const boundRect = event.currentTarget.getBoundingClientRect();
        let nScrollY = divProjectContainer?.scrollTop;
        // 取得鼠标按下时的坐标位置
        downX = event.clientX - boundRect.left;
        downY = event.clientY - boundRect.top //+ nScrollY;
        rect.style.left = downX + "px";
        rect.style.top = downY + "px";
    }

    const onMouseUp = (event)=>{

        //鼠标抬起,就不允许在处理鼠标移动事件
        select = false;
        //隐藏图层
        if (rect) {
            try{
                const divProjectContainer:any = document.getElementById('div-project-list-container');
                divProjectContainer?.removeChild(rect);
            }catch (e){

            }

            rect = null;
        }
    }

    const onMouseMove = (event:any)=>{
        //如果有打开的对话框，这个不要处理了。。。。
        if(window.getDialogCardsCount() > 0)return;
        /*
                        这个部分,根据你鼠标按下的位置,和你拉框时鼠标松开的位置关系,可以把区域分为四个部分,根据四个部分的不同,
                        我们可以分别来画框,否则的话,就只能向一个方向画框,也就是点的右下方画框.

                        */
        const boundRect = event.currentTarget.getBoundingClientRect();
        const divItemContainer = document.getElementById('div-project-list-container');
        let nScrollY = divItemContainer?.scrollTop;
        // 取得鼠标移动时的坐标位置
        mouseX2 = event.clientX - boundRect.left;
        mouseY2 = event.clientY - boundRect.top //+ nScrollY;


        const time = new Date().getTime();

        if (Math.abs(mouseX2 - downX) < 8 && Math.abs(mouseY2 - downY) < 8 && (time - mMouseDownTime) < 500){
            // select = false;
            return;
        }

        if(select)
        {

            //自动滚动
            // console.log('scrollY:'+nScrollY);
            // console.log('clientY:'+event.clientY);
            // console.log('pageY:'+event.pageY);
            // console.log('screenY:'+event.screenY);
            // console.log('height:'+divItemContainer.clientHeight);
            console.log('**********:**********:');

            // 显示框选元素
            if (rect.style.display == "none") {
                rect.style.display = "";
            }
            rect.style.left =Math.min(mouseX2, downX) + "px";

            rect.style.top = Math.min(mouseY2, downY) + "px";

            rect.style.width = Math.abs(mouseX2 - downX) + "px";

            rect.style.height = Math.abs(mouseY2 - downY) + "px";
            // A part
            if( mouseX2 < downX && mouseY2 < downY ){
                rect.style.left = mouseX2;
                rect.style.top = mouseY2 ;
            }

            // B part
            if( mouseX2 > downX && mouseY2 < downY){
                rect.style.left = downX ;
                rect.style.top = mouseY2;
            }

            // C part
            if( mouseX2 < downX && mouseY2 > downY){
                rect.style.left = mouseX2;
                rect.style.top = downY ;
            }

            // D part
            if( mouseX2 > downX && mouseY2 > downY ){
                rect.style.left = downX ;
                rect.style.top = downY;
            }


            //待选中的列表....
            var lis = document.getElementsByClassName('carditem');
            var arrayNewList = [...noteList];
            let nCheckedCount = 0;

            for (let i = 0; i < lis.length; i++) {
                //将移动的div的四个点和和div元素的四个点进行比较
                const cardItem = lis[i];
                if (!cardItem)continue;
                const arrayFilters = arrayNewList.filter(p=>p.id == cardItem.dataset.id);
                let item:any = null;
                if (arrayFilters.length > 0){
                    item = arrayFilters[0];
                }
                if (!item || props.from == FROM_RIGHT_SIDE)continue;

                let nItemOffsetTop = lis[i].offsetTop;
                let nRectOffsetTop = rect.offsetTop //+ nScrollY;
                if (
                    //判断div元素 右边框的位置大于移动div的左起始点
                    rect.offsetLeft < (lis[i].offsetLeft + lis[i].offsetWidth ) &&
                    //判断div元素 下边框的位置大于移动div的上起始点
                    (nItemOffsetTop + lis[i].offsetHeight) >nRectOffsetTop
                    &&
                    // 判断div元素左边框的位置小于移动div的右起始点
                    rect.offsetLeft + rect.offsetWidth > lis[i].offsetLeft&&
                    // 判断div元素上边框的位置小于移动div的下起始点
                    nRectOffsetTop + rect.offsetHeight > nItemOffsetTop
                ) {
                    //将已选中的样式改变
                    item.isChecked = true;
                    nCheckedCount ++;
                    // mLastSelectedIds.current[item.id] = true;
                } else {
                    //如果没有选中则清除样式
                    // item.isChecked = false;
                }
            }

            if (props.from != FROM_RIGHT_SIDE){
                if (nCheckedCount > 0){
                    if (!isShowChecked){
                        setIsShowChecked(true);
                    }

                    let szSelectedTitle = t("Items selected").replace('{0}',arrayNewList.filter(p=>p.isChecked).length+'');
                    setShowCheckedTitle(szSelectedTitle)
                }
                setNoteList(arrayNewList);
            }
        }

        // 阻止事件上传
        // window.event.cancelBubble = true;
        // // // 阻止默认事件
        // window.event.returnValue = false;
    }
    //endregion

    function resizeWindow() {

        /*
        const margin = 11;
        let nItemCount = 4;

        // var item = document.getElementById("#divList");
        //左边菜单240 -- 间距margin左右各20  每个item的间距 8
        let nWidth = (document.body.clientWidth - 241 - (nItemCount) * (margin * 2) - 30 + 11) / nItemCount;
        let nHeight = nWidth * 9 / 16;
        if (nWidth > 390) {
            nWidth = 390;
        }
        setNoteItemWidth(nWidth + 'px');

        let nClientWidth = document.body.clientWidth;
        if (nClientWidth < RESPONSE_LAYOUT_L1) {
            nItemCount = 4;
        } else if (nClientWidth < RESPONSE_LAYOUT_L2) {
            nItemCount = 5;
        } else {
            nItemCount = 6;
        }
        setColumnTemplate(`repeat(${nItemCount},1fr)`)

        if (props.from == FROM_RIGHT_SIDE) {
            setColumnTemplate(`repeat(${2},1fr)`)
        }
         */
    }

    /**
     * 拖拽的时候窗口宽度调整...
     */
    function onResizeEvent(nWidth: number) {
        let COLUMN_COUNT = 0;
        if (nWidth > WIDTH_5) {
            COLUMN_COUNT = 5;
            setColumnTemplate('repeat(5,1fr)');
        } else if (nWidth > WIDTH_4) {
            COLUMN_COUNT = 4;
            setColumnTemplate('repeat(4,1fr)');
        } else if (nWidth > WIDTH_3) {
            COLUMN_COUNT = 3;
            setColumnTemplate('repeat(3,1fr)');
        } else {
            COLUMN_COUNT = 2;
            setColumnTemplate('repeat(2,1fr)');
        }

        let fItemWidth = 200;
        const nMargin = (COLUMN_COUNT - 1) * 16;
        fItemWidth = (nWidth - nMargin - 40) / COLUMN_COUNT;//40为左右2边的边距
        setItemSize({width: fItemWidth, height: fItemWidth * 0.68})
    }

    /**
     * 搜索
     * @param szKey
     */
    const onSearch = (szKey: any) => {
        mSearchKey = szKey;
        onSearchResult();
    }



    /*
    useEffect(() => {
        if (isInSidebar()) {
            return;//侧栏不需要
        }
        var szFolderName = locationParams.state?.usr?.folderName;
        if (szFolderName != undefined) {
            setFolderName(szFolderName);
        }

        mFolderId = locationParams.state?.usr?.folderId;
        if ('-2' == mFolderId) {
            initFolderInfo();
        } else {
            if (!isStringNullOrEmpty(mFolderId) && szFolderName == undefined) {
                getFolderById(mFolderId).then(res => {
                    setFolderName(res.name);
                })
            }
        }

        mPageNum.current = 0;
        updateNoteList();

        setSearchKey('');

        recvMessage(POST_MESSAGE_REFRESH_FOLDER_LIST, (msg, data) => {
            if ('-2' == mFolderId) {
                initFolderInfo();
            }
        }, false);

        return () => {
            unSubscribe(POST_MESSAGE_REFRESH_FOLDER_LIST);
        }
    }, [locationParams.state?.usr?.folderId])

     */

    /*文件夹信息*/
    const initFolderInfo = async () => {
        // var arrayNotes = await getNoteList();
        // arrayNotes = arrayNotes.filter(p=>0 === p.isDeleted);
        allFolder().then(async (res) => {
            res.sort((a, b) => {
                return a.createTime - b.createTime;
            })
            // let arrayPromise = [];
            for (let i = 0; i < res.length; i++) {
                // arrayPromise.push(staticFolderNoteCount(res[i].id))
                res[i].projectCount = await staticFolderNoteCount(res[i].id);
            }

            setArrayFolders(res);
        })
    }

    const initData = async () => {
        if (isInSidebar()) return;
        let szDateformat = DEFAULT_DATE_FORMAT;
        const sysConfigDateformat: any = localStorage.getItem(SYS_CONFIG_KEY_DATEFORMAT);
        if (!isStringNullOrEmpty(sysConfigDateformat)) {
            szDateformat = sysConfigDateformat;
        }
        Global.g_dateFormat = szDateformat;
        if (isFirstShow) {
            setIsLoadingNoteList(true);
        }
        isFirstShow = false;
        isQuerying.current = false;
        // updateNoteList();
        updateTagList();
    }

    const refreshSingleProjectItem = async (szProjectId) => {
        const arrayNewList = [...noteList];
        const nIndex = arrayNewList.findIndex(p => p.id == szProjectId);
        if (nIndex != -1) {
            const dbData = await getProjectById(szProjectId, false);
            if (dbData) {
                arrayNewList.splice(nIndex, 1, dbData);
                setNoteList(arrayNewList);
            }
        }
    }

    /**
     * 刷新列表数量
     */
    const refreshProjectList = ()=>{
        updateNoteList(null,false,0);
    }

    const refreshProjectListInFavor = ()=>{
        if (mActiveTabItemRef.current?.id == 'favorites'){
            refreshProjectList();
        }
    }


    /**
     * 移除一个项目
     * @param szProjectId
     */
    const removeProjectById = (szProjectId) =>{
        const arrayNewList = [...noteList];
        const nIndex = arrayNewList.findIndex(p => p.id == szProjectId);
        if (nIndex != -1){
            arrayNewList.splice(nIndex,1);
            setNoteList(arrayNewList);
            setProjectCount(arrayNewList.length);
        }
    }

    /**
     * 移除一个项目
     * @param szProjectId
     */
    const removeProjectInFavorById = (szProjectId) =>{
        if (mActiveTabItemRef.current?.id == 'favorites'){
            const arrayNewList = [...noteList];
            const nIndex = arrayNewList.findIndex(p => p.id == szProjectId);
            if (nIndex != -1){
                arrayNewList.splice(nIndex,1);
                setNoteList(arrayNewList);
                setProjectCount(arrayNewList.length);
            }
        }
    }

    /**
     * 更新标签列表
     */
    const updateTagList = () => {
        getTagList().then(res => {
            mArrayTags.length = 0;

            if (res.length > 0) {
                mArrayTags.push({
                    value: FILTER_TAG_NO_TAGS,
                    label: t("No tags")
                })

                mArrayTags.push({
                    id: MENU_SEPARATOR,
                    value: generateUUID2()
                })
            }

            res.forEach(p => {
                mArrayTags.push({
                    value: p.id,
                    label: p.name
                })
            })
            setArrayTags(mArrayTags);
        })
    }

    /**排序*/
    const onSortMenuClick = (e) => {
        if ("sort by name" == e.key || "sort by createDate" == e.key || "sort by updateDate" == e.key) {
            // updateSortOrderByMenu(e.key);
            setSortMenuOpen(true);
            // updateSysConfig(SYS_CONFIG_KEY_SORT_TYPE,e.key);
            localStorage.setItem(SYS_CONFIG_KEY_SORT_TYPE, e.key);
            //默认选中Order by 的第一个.
            if ("sort by name" == e.key) {
                onSortMenuClick({key: 'a-z'})
            } else {
                onSortMenuClick({key: 'date desc'})
            }
        } else {
            setSortMenuOpen(false);
            // updateSysConfig(SYS_CONFIG_KEY_ORDER_BY,e.key);
            localStorage.setItem(SYS_CONFIG_KEY_ORDER_BY, e.key);
            //更新列表
            updateNoteList();
        }
        updateSortStates();
    }

    /*排序状态选中*/
    const updateSortStates = async () => {
        let szSortType: any = localStorage.getItem(SYS_CONFIG_KEY_SORT_TYPE)// || 'sort by updateDate';// await getSysConfig(SYS_CONFIG_KEY_SORT_TYPE);
        let szOrderBy: any = localStorage.getItem(SYS_CONFIG_KEY_ORDER_BY)// || 'date desc'; //await getSysConfig(SYS_CONFIG_KEY_ORDER_BY);
        if (!szSortType) {
            const dbConfig = await getSysConfig(SYS_CONFIG_KEY_SORT_TYPE);
            if (dbConfig && dbConfig.value) {
                szSortType = dbConfig.value;
            } else {
                szSortType = 'sort by updateDate';
            }
            localStorage.setItem(SYS_CONFIG_KEY_SORT_TYPE, szSortType)
        }
        if (!szOrderBy) {
            const dbConfig = await getSysConfig(SYS_CONFIG_KEY_ORDER_BY);
            if (dbConfig && dbConfig.value) {
                szOrderBy = dbConfig.value;
            } else {
                szOrderBy = 'date desc';
            }
            localStorage.setItem(SYS_CONFIG_KEY_ORDER_BY, szOrderBy)
        }
        // if(szSortType != undefined){
        //     szSortType = szSortType.value;
        // }else{
        //     szSortType = "sort by updateDate";
        // }
        // if(szOrderBy != undefined){
        //     szOrderBy = szOrderBy.value;
        // }else{
        //     szOrderBy = "date desc"
        // }

        var arraySortMenus = [...sortMenu];
        if ("sort by name" == szSortType) {
            var sortMenuA = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'a-z',
                        label: 'A-Z',
                        icon: <CheckOutlined/>,
                    },
                    {
                        key: 'z-a',
                        label: 'Z-A'
                    }
                ]
            }
            arraySortMenus[1] = sortMenuA;
        } else {
            var sortMenuDate = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'date asc',
                        label: t('Oldest first')
                    },
                    {
                        key: 'date desc',
                        label: t('Newest first')
                    }
                ]
            }
            arraySortMenus[1] = sortMenuDate;
        }

        var item0 = arraySortMenus[0];
        for (var i = 0; i < item0.children.length; i++) {
            var child = item0.children[i];

            if (child.key == szSortType) {
                child.icon = <CheckOutlined/>;
            } else {
                child.icon = <CheckOutlined style={{color: 'white', fontSize: '0px'}}/>;
            }
        }

        var item1 = arraySortMenus[1];
        for (var i = 0; i < item1.children.length; i++) {
            var child = item1.children[i];

            if (child.key == szOrderBy) {
                child.icon = <CheckOutlined/>;
            } else {
                child.icon = <CheckOutlined style={{color: 'white', fontSize: '0px'}}/>;
            }
        }

        setSortMenu(arraySortMenus);
    }

    /**
     * 更新排序的描述
     * @param szSortType
     */
    const updateSortTypeDesc = (szSortType) => {
        for (var i = 0; i < sortMenu[0].children.length; i++) {
            var item = sortMenu[0].children[i];
            if (item.key == szSortType) {
                setSortTypeDesc(item.label);
                mSortTypeDesc = item.label;
            }
        }
    }

    /**
     * 当tag修改的时候刷新列表
     */
    const refreshWhenTagUpdate = async () => {
        mPageNum.current = 0;
        await updateNoteList(null, true);
    }

    function paginateArray(array: any, pageSize: any, pageNumber: any) {
        // 计算起始索引
        const startIndex = (pageNumber) * pageSize;

        // 返回当前页的数据
        return array.slice(startIndex, startIndex + pageSize);
    }

    const updateNoteListPub = () => {
        updateTagList(null, false, 0);
    }

    /*更新带排序的笔记列表*/
    const updateNoteList = (szTagName = null, isUpdateTag = false, nPageNum = 0) => {
        mPageNum.current = nPageNum;
        if (isQuerying.current) {
            console.log('is querying  return');
            return
        }
        isQuerying.current = true;
        // setNoteList(mArrayNoteListCache);

        if (szTagName != null) {//外面传过来的。
            mSelectTag.current = szTagName;
        }

        let isShowHiddenProject = localStorage.getItem(KEY_SHOW_HIDIN_PROJECTS) == 'true';

        if (mActiveTabItemRef.current?.id == 'published'){
            getPublishProjectList('project').then(async (arrayNotes:any)=>{
                if (mSelectTag.current) {
                    if (mSelectTag.current == FILTER_TAG_NO_TAGS + '-----') {
                        arrayNotes = arrayNotes.filter(p => !p.isDefaultProject && (!p.tags || (p.tags && p.tags.length == 0)))
                    } else {
                        arrayNotes = arrayNotes.filter(p => !p.isDefaultProject && p.tags && p.tags.includes(mSelectTag.current))
                    }
                } else {
                    arrayNotes = arrayNotes.filter(p => !p.isDefaultProject);
                }
                if (isShowHiddenProject){
                    arrayNotes = arrayNotes.filter(p=>p.isHidden == 1);
                }else{
                    arrayNotes = arrayNotes.filter(p=>p.isHidden != 1);
                }

                mArrayNoteListCache.current.length = 0;
                mArrayNoteListCache.current.push(...arrayNotes);

                setProjectCount(arrayNotes.length);

                if (mPageNum.current != -1) {
                    arrayNotes = paginateArray(arrayNotes, PAGE_SIZE, mPageNum.current);
                }

                await sortList(arrayNotes);
                if (isUpdateTag) {
                    updateTagList();
                }
            })
        }else{
            let isFavor = mActiveTabItemRef.current?.id == 'favorites';
            getNoteList(0, mFolderId, -1,isFavor).then(async (arrayNotes: any) => {
                if (mSelectTag.current) {
                    if (mSelectTag.current == FILTER_TAG_NO_TAGS + '-----') {
                        arrayNotes = arrayNotes.filter(p => !p.isDefaultProject && (!p.tags || (p.tags && p.tags.length == 0)))
                    } else {
                        arrayNotes = arrayNotes.filter(p => !p.isDefaultProject && p.tags && p.tags.includes(mSelectTag.current))
                    }
                } else {
                    arrayNotes = arrayNotes.filter(p => !p.isDefaultProject);
                }
                if (isShowHiddenProject){
                    arrayNotes = arrayNotes.filter(p=>p.isHidden == 1);
                }else{
                    arrayNotes = arrayNotes.filter(p=>p.isHidden != 1);
                }

                setProjectCount(arrayNotes.length);

                mArrayNoteListCache.current.length = 0;
                mArrayNoteListCache.current.push(...arrayNotes);

                if (mPageNum.current != -1) {
                    arrayNotes = paginateArray(arrayNotes, PAGE_SIZE, mPageNum.current);
                }

                await sortList(arrayNotes);
                if (isUpdateTag) {
                    updateTagList();
                }
                //强制回收.
                // setTimeout(()=>{
                //     ipcInvoke('gc-collection');
                // },100);
            });
        }
    }

    /**
     * 排序....
     * @param arrayNotes
     */
    const sortList = async (arrayNotes: any) => {
        isQuerying.current = false;

        if (arrayNotes.length == 0) {
            if (mPageNum.current == 0) {
                setIsLoadingNoteList(false);
                setNoteList([]);
            }
            return
        }

        let szSortType: any = localStorage.getItem(SYS_CONFIG_KEY_SORT_TYPE)// || "sort by updateDate";//await getSysConfig(SYS_CONFIG_KEY_SORT_TYPE);
        let szOrderBy = localStorage.getItem(SYS_CONFIG_KEY_ORDER_BY)// || "date desc"; //await getSysConfig(SYS_CONFIG_KEY_ORDER_BY);

        if (!szSortType) {
            const dbConfig = await getSysConfig(SYS_CONFIG_KEY_SORT_TYPE);
            if (dbConfig && dbConfig.value) {
                szSortType = dbConfig.value;
            } else {
                szSortType = 'sort by updateDate';
            }
            localStorage.setItem(SYS_CONFIG_KEY_SORT_TYPE, szSortType)
        }

        //更新排序描述文字
        updateSortTypeDesc(szSortType);

        /*排序放在数据库查询了
        if("sort by name" === szSortType){
            if("a-z" === szOrderBy){
                arrayNotes.sort((a,b)=>{
                    if(a.showName == undefined || b.showName == undefined)return 0;
                    return a.showName.localeCompare(b.showName);
                })
            }else if("z-a" == szOrderBy){
                arrayNotes.sort((a,b)=>{
                    if(a.showName == undefined || b.showName == undefined)return 0;
                    return b.showName.localeCompare(a.showName);
                })
            }
        }else if("sort by createDate" == szSortType){
            if("date asc" == szOrderBy){
                arrayNotes.sort((a,b)=>{
                    return a.createTime - b.createTime;
                })
            }else if("date desc" == szOrderBy){
                arrayNotes.sort((a,b)=>{
                    return b.createTime - a.createTime;
                })
            }
        } else if("sort by updateDate" == szSortType){
            if("date asc" == szOrderBy){
                arrayNotes.sort((a,b)=>{
                    return a.updateTime - b.updateTime;
                })
            }else if("date desc" == szOrderBy){
                arrayNotes.sort((a,b)=>{
                    return b.updateTime - a.updateTime;
                })
            }
        }*/

        // var sub = arrayNotes.length % global.g_home_project_count;
        // if (sub != 0){
        //     //补充元素
        //     for(var i=0;i<(global.g_home_project_count-sub);i++){
        //         arrayNotes.push({
        //             id:'-1'
        //         })
        //     }
        // }
        //这里处理一下，如果有thumbUrl，img全部置空....重新保存....
        asyncUpdateImgBase64(arrayNotes);

        setIsShowEmptyData(arrayNotes.length == 0);

        //第一个 插入一个新建项目
        if (props.from == FROM_RIGHT_SIDE) {
            const newItem = {
                id: 'newProject',
                thumbUrl: 'add_gray.png'
            }
            arrayNotes.splice(0, 0, newItem);
        }

        const arrayNew: any = [];
        if (mPageNum.current > 0) {
            arrayNew.push(...noteList);
        }
        arrayNew.push(...arrayNotes);

        //如果原来有选中，继续保持选中..
        const arrayKeys = Object.keys(mMapIdCheckRef.current);
        for (let i=0;i<arrayKeys.length;i++){
            const item = arrayNew.find(p=>p.id == arrayKeys[i]);
            if (item){
                item.isChecked = true;
            }
        }

        setNoteList(arrayNew);
        setIsLoadingNoteList(false);
    }

    /**
     * 处理一下base64问题.
     * @param arrayNotes
     */
    const asyncUpdateImgBase64 = (arrayNotes: any) => {
        return new Promise(async (resolve) => {
            for (let i = 0; i < arrayNotes.length; i++) {
                const item = arrayNotes[i];
                if (item.thumbUrl) {
                    if (item.img) {
                        item.img = '';
                        await updateProject(item);
                    }
                } else {
                    if (item.img && isBase64(item.img)) {
                        //保存为base64
                        const arraySplit = item.img.split(',');
                        const data = arraySplit[0];
                        const arraySplit1 = data.split(';');
                        const mime = arraySplit1[0].replace('data:', '');
                        const fileName = item.id + '.' + extFromMineType(mime);
                        await ipcInvoke('write-base64-image', {imgBase64: item.img, fileName: fileName});
                        item.thumbUrl = fileName;
                        await updateProject(item);
                    }
                }
            }
        })
    }

    /*更新排序菜单，显示不同order*/
    const updateSortOrderByMenu = (szKey) => {
        var arrayNewMenu = [...sortMenu];
        if ("sort by name" == szKey) {
            var sortMenuA = {
                key: "order",
                type: 'group',
                label: 'order',
                children: [
                    {
                        key: 'a-z',
                        label: 'A-Z',
                        icon: <CheckOutlined/>,
                    },
                    {
                        key: 'z-a',
                        label: 'Z-A'
                    }
                ]
            }
            arrayNewMenu[1] = sortMenuA;
        } else {
            var sortMenuDate = {
                key: "order",
                type: 'group',
                label: 'order',
                children: [
                    {
                        key: 'date asc',
                        label: 'Oldest first'
                    },
                    {
                        key: 'date desc',
                        label: 'Newest first'
                    }
                ]
            }
            arrayNewMenu[1] = sortMenuDate;
        }

        setSortMenu(arrayNewMenu);
    }
    /*排序菜单显示状态更改*/
    const handleSortOpenChange = (nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setSortMenuOpen(nextOpen);
        }
    }

    /** 导入笔记 */
    const importNote = useCallback(() => {
        // ipcInvoke("openFileExt",{filters:[{name: 'Canvas', extensions: ['pcanvas','pcanvasx']}]}).then(data=>{
        //     if (data != undefined && data.hasOwnProperty("data")){
        //         onImportNote(data.data,data.filePath)
        //     }
        // })
        dialogImportRef.current?.onShowDialog();
    }, []);


    /**选择文件后这里开始导入*/
    const onImportNote = async (strData, filePath) => {
        const jsonObj = JSON.parse(strData);

        if (filePath.toLowerCase().endsWith('pcanvasx') || !jsonObj.info?.isReadOnlyStatus) {
            if (jsonObj.info?.isBackupMode) {
                if (localStorage.getItem(KEY_MACHINEID) != jsonObj.info.deviceId) {
                    dialogMessageBoxRef.current?.onShowDialogWithoutCancel(t("NoPermissions"), t("ApologiesNoPermission"), t("See plans"), () => {
                        postMessage(EVENT_SHOW_DESKTOP_PRO_VIP, {from: DESKTOP_PRO_FROM_IMPORT_BACKUP_FILE});
                        window.closeIndicator();
                    });
                    return;
                }
            } else {
                if (await hasBeyondFreeLimit()) {
                    postMessage(EVENT_SHOW_DESKTOP_PRO_VIP, {from: ''});
                    window.closeIndicator();
                    return;
                }
            }
        }

        jsonObj.folderId = '';//导入的置空....
        const szFilePath = filePath;
        //打开画布 直接打开画布，进入card全屏后，回退，会重新进入导入的这个状态，带着了这些数据。所以有问题。给个提示
        // var szFolderId = locationParams.state?.usr?.folderId;
        // if (!isStringNullOrEmpty(mCreateProjectFolderId)){
        //     szFolderId = mCreateProjectFolderId;
        // }
        // navigate(getDrawPath(),{state:{importNoteData:jsonObj,isReadOnlyState:jsonObj.info?.isReadOnlyStatus,folderId:szFolderId}});

        window.saveImportProject(jsonObj).then(res => {
            window.closeIndicator();
            //刷新
            updateNoteList();

            //这里给个提示
            window.showMessageBox(t("Tips"), t("ProjectHasImport"), t("Cancel"), t("Open"), null, () => {
                //open....
                window.navigateOrigin(getDrawPath(), {state: {noteData: res, searchKey: ''}});
            })
        });

        mCreateProjectFolderId = '';
    }


    /**
     * 创建新文件夹
     */
    const createNewFolder = () => {
        dialogNewFolderRef?.current?.onShowDialogEvent();
    }

    const btnViewStyleClicked = (viewType) => {
        viewType = viewStyle == VIEW_STYLE.VIEW_STYLE_GRID ? VIEW_STYLE.VIEW_STYLE_LIST : VIEW_STYLE.VIEW_STYLE_GRID;
        setViewStyle(viewType);
        updateSysConfig(SYS_CONFIG_KEY_VIEW_STYLE, viewType);
    }

    const onShowDialogMoveFolder = (data) => {
        dialogMovetoFolderRef.current?.onShowDialogEvent(data);
    }

    /**
     * 更换缩略图
     */
    const changeThumb = (item) => {
        dialogChooseThumbRef.current?.onShowDialog((szImgName: any) => {
            //更新这个缩略图
            item.thumbUrl = szImgName;

            var arrayDatas: any = [...noteList];
            const note = arrayDatas.find(p => p.id == item.id);
            if (note) {
                note.thumbUrl = szImgName;
                setIsShowEmptyData(arrayDatas.length == 0);
                setNoteList(arrayDatas);
                //更新
                updateNote(note).then(res => {

                });
            }
        });
    }

    /**
     * 取选中的条目
     */
    const getSelectedArray = ()=>{
        return noteList.filter(p=>p.isChecked);
    }

    //标题
    const renderListViewTitle = () => {
        if (viewStyle == VIEW_STYLE.VIEW_STYLE_LIST) {
            return (
                <div style={{display: 'flex', alignItems: 'center', padding: '4px 16px'}}>
                    <span className='gray' style={{flexGrow: '1', minWidth: '236px'}}>{t("Name")}</span>

                    <div className='list-conent-right text-color-a'>
                        <span className='w-cell-item align-left' style={{width: '200px'}}>{t("Info")}</span>
                        <span className='w-cell-item align-left'>{t("Last modified")}</span>
                        <span className='w-cell-item align-left ml-item_margin'>{t("Created time")}</span>
                        <span className='w-cell-item-more ml-item_margin'></span>
                    </div>
                </div>
            )
        } else {
            return (
                <></>
            )
        }
    }

    /*渲染列表*/
    const renderNoteList = () => {
        if (isShowEmptyData) {
            return <Empty className='empty'/>
        }

        return <div style={{
            display: viewStyle === VIEW_STYLE.VIEW_STYLE_GRID ? "grid" : 'flex',
            gridTemplateColumns: columnTemplate,
            gap: props.from == FROM_RIGHT_SIDE ? '16px 16px' : '16px 16px',
            // flexWrap: 'wrap',justifyContent:'space-between',
            flexDirection: viewStyle === VIEW_STYLE.VIEW_STYLE_GRID ? "row" : "column",
            padding: viewStyle === VIEW_STYLE.VIEW_STYLE_GRID ? '0 16px 22px 16px' : '0px 0px 28px 0px'
        }}>
            {
                noteList.map((item, i) =>
                    <Note key={i} data={item} itemSize={itemSize} viewStyle={viewStyle} from={FROM_HOME}
                          isShowChecked={isShowChecked}
                          subFrom={props.from} showMoveDialog={onShowDialogMoveFolder}
                          onItemClickCallback={(data: any) => {
                              if (props.onCallback) {
                                  props.onCallback('nagivator', data);
                              }
                          }} onAction={(szAction: any, item: any) => {
                        if ("managerTags" == szAction) {
                            dialogTagManagerRef.current?.onShowDialog([item]);
                        } else if ("changeThumbnail" == szAction) {
                            changeThumb(item);
                        }else if ('onChecked' == szAction){
                            const nSelectCount = getSelectedArray().length;
                            let szSelectedTitle = t("Items selected").replace('{0}',nSelectCount+'');
                            setShowCheckedTitle(szSelectedTitle)
                        }else if ('managerTagsMultiply' == szAction){
                            managerTagsEvent();
                        }else if ('deleteMultiply' == szAction){
                            deleteSelectedEvent();
                        }
                    }}/>
                )
            }
        </div>
    }

    /*搜索结果列表*/
    const renderSearchNoteList = () => {
        return <div style={{
            display: "grid",
            gridTemplateColumns: columnTemplate,
            gap: props.from == FROM_RIGHT_SIDE ? '12px 12px' : '26px 26px',
            padding: '0',
            // flexWrap: 'wrap', justifyContent:'space-between',
            flexDirection: "row"
        }}>
            {
                noteSearchList.map((item, i) =>
                    <Note searchKey={searchKey} key={i} data={item} itemSize={itemSize} from={FROM_HOME}
                          subFrom={props.from} viewStyle={VIEW_STYLE.VIEW_STYLE_GRID}
                          onItemClickCallback={(data: any) => {
                              if (props.onCallback) {
                                  props.onCallback('nagivator', data);
                              }
                          }} onAction={(szAction: any, item: any) => {
                        if ("managerTags" == szAction) {
                            dialogTagManagerRef.current?.onShowDialog([item]);
                        }
                    }}/>
                )
            }
        </div>
    }

    /**
     * 新建工程文件
     * @param szType
     */
    const onNewProjectEvent = async (szType: string) => {
        if (await hasBeyondFreeLimit()) {
            postMessage(EVENT_SHOW_DESKTOP_PRO_VIP, {from: ''})
            return;
        }
        if ("blank" === szType) {
            //新建的保存唯一的ID，刷新也不变....
            // const szNewProjectId = generateUUID2();
            // localStorage.setItem(KEY_NEW_PROJECT_ID,szNewProjectId);
            // // PROJECT_ID = generateUUID2();
            //
            // var szFolderId = locationParams.state?.usr?.folderId;
            // if (!isStringNullOrEmpty(mCreateProjectFolderId)){
            //     szFolderId = mCreateProjectFolderId;
            // }
            // window.navigateOrigin(getDrawPath(),{state:{folderId:szFolderId,projectId:szNewProjectId,isNew:true}});
            // mCreateProjectFolderId = '';

            if (await hasBeyondFreeLimit()) {
                postMessage(EVENT_SHOW_DESKTOP_PRO_VIP, {from: ''})
                return;
            }
            const szNewProjectId = generateUUID2();
            localStorage.setItem(KEY_NEW_PROJECT_ID, szNewProjectId);
            //创建一个空白项目保存
            const newProject = createEmptyProject(szNewProjectId, '');
            await updateNote(newProject);
            postMessage(EVENT_REFRESH_RECENTS);
            window.navigateOrigin(getDrawPath(), {state: {noteData: newProject}});

        } else if ("template" == szType) {
            dialogTemplateRef.current?.onShowDialog();
        } else if ("import" == szType) {
            importNote();
        }
    }

    /**
     * 模板点击--NEW。。。
     */
    const onTemplateItemClick = (szFileName) => {
        var szFilePath = templatePathPerfix() + "/" + szFileName + ".template";
        ipcInvoke("read-file", {filePath: szFilePath}).then(res => {
            const jsonObj = JSON.parse(res);
            //打开画布
            var szFolderId = locationParams.state?.usr?.folderId;
            if (!isStringNullOrEmpty(mCreateProjectFolderId)) {
                szFolderId = mCreateProjectFolderId;
            }
            window.navigateOrigin(getDrawPath(), {
                state: {
                    importNoteData: jsonObj,
                    isReadOnlyState: false,
                    folderId: szFolderId
                }
            });
            mCreateProjectFolderId = '';
        })
    }

    /**
     * 展开或折叠笔记。只有folderId=-2有效
     */
    const onExpandOrCollapseNote = () => {
        setIsNoteListVisible(!isNoteListVisible);
    }

    /*鼠标进入*/
    const onFolderMouseEnter = (e) => {
        var nIndex = e.currentTarget.dataset.index;
        var arrayNew = [...arrayFolders];
        arrayNew.forEach(p => p.showMore = false);
        var item = arrayNew[nIndex];
        item.showMore = true;
        setArrayFolders(arrayNew);
    }
    /*鼠标离开*/
    const onFolderMouseLeave = (e) => {
        var nIndex = e.currentTarget.dataset.index;
        var arrayNew = [...arrayFolders];
        arrayNew.forEach(p => p.showMore = false);
        setArrayFolders(arrayNew);
    }
    /*双击进到文件夹里面*/
    const onFolderDoubleClick = (e) => {
        var nIndex = e.currentTarget.dataset.index;
        var currentFolder = arrayFolders[nIndex];
        postMessage(EVENT_SELECTED_FOLDER, currentFolder);
    }
    /*文件夹更多*/
    const onFolderMoreClickEvent = (e) => {
        e.domEvent.stopPropagation();
        var currentFolder = arrayFolders.find(p => p.showMore);
        if ("newProject" === e.key) {
            window.navigateOrigin(getDrawPath(), {state: {folderId: currentFolder?.id}})

            // mCreateProjectFolderId = currentFolder?.id;
            // dialogNewProjectRef?.current.showNewProjectDialog();
        } else if ("rename" == e.key) {
            dialogNewFolderRef.current?.onShowDialogEvent(currentFolder);
        } else if ('delete' === e.key) {
            /*
            Modal.confirm({
                content:t("Confirm delete the folder"),
                onOk(){
                    deleteFolder(currentFolder.id).then(res=>{
                        postMessage(EVENT_NOTE_CHANGED);
                        postMessage(POST_MESSAGE_REFRESH_FOLDER_LIST);
                    });
                }
            })*/
            dialogMessageBoxRef.current?.onShowDialog(t("Confirm delete"), t("Confirm delete the folder"), t("Delete"), () => {
                deleteFolder(currentFolder.id).then(res => {
                    postMessage(EVENT_NOTE_CHANGED);
                    postMessage(POST_MESSAGE_REFRESH_FOLDER_LIST);
                });
            })
        }
    }

    /**
     * 更新文件夹确定.....
     */
    const onFolderUpdateOk = () => {
        initFolderInfo();
    }

    /**
     * 读取空白的提示
     */
    const getEmptyTips = ()=>{
        let szTips = '';
        if (activeTabItem?.id == 'favorites'){
            szTips = t('NoFavoriteProjectsYet')
        }else if (activeTabItem?.id == 'published'){
            szTips = t('NoProjectsPublishedYet');
        }
        return szTips;
    }

    /**
     * 搜索
     * @param e
     */
    const onSearchChange = (e) => {
        var szKey = e.currentTarget.value;
        mSearchKey = szKey.trim();
        setSearchKey(szKey);
        if (szKey) {
            setIsSearching(true);
        }

        clearTimeout(mSearchTimeout.current);
        mSearchTimeout.current = setTimeout(() => {
            onSearchResult();
        }, 1000)

    }

    /*搜索结果*/
    const onSearchResult = () => {

        if (isStringNullOrEmpty(mSearchKey)) {
            if (window.closeRightSliderSearch) {
                window.closeRightSliderSearch();
            }
            setIsSearching(false);
            return;
        }

        let isFavor = mActiveTabItemRef.current?.id == 'favorites';
        let isPublish = mActiveTabItemRef.current?.id == 'published';

        getSearchNoteList(mSearchKey,false,isFavor,isPublish).then(res => {
            var arraySearchs: any = [...res];
            //未补充的实际数量 ...
            // setNoteSearchListCount(arraySearchs.length);
            mMapIdCheckRef.current = {};

            setIsSearching(false);
            if (window.closeRightSliderSearch) {
                window.closeRightSliderSearch();
            }
            // setNoteSearchList(arraySearchs);
            setNoteList(arraySearchs);
            setProjectCount(arraySearchs.length);
        })
        /*
        getNoteList(false,true).then(res=>{
            var arraySearchs = [];
            var szKeyLower = mSearchKey.toLowerCase();
            res.forEach((p)=>{
                if (!p.isDeleted){
                    var bFind = false;
                    if(p.name.toLowerCase().indexOf(szKeyLower) != -1){
                        arraySearchs.push(p);
                    }else{
                        if (!isStringNullOrEmpty(p.doc)){
                            var jsonDoc = JSON.parse(p.doc);
                            var jsonPages = jsonDoc.canvas;
                            for (var nPages = 0;nPages<jsonPages.length;nPages++){
                                var page = jsonPages[nPages];
                                if(page.drawJson != undefined && page.drawJson.elements != undefined){
                                    var arrayEles = page.drawJson.elements;
                                    for (var i=0;i<arrayEles.length;i++){
                                        var ele = arrayEles[i];
                                        if (ele.type === 'text'){
                                            if (ele.text.toLowerCase().indexOf(mSearchKey) != -1){
                                                bFind = true;
                                                arraySearchs.push(p);
                                                break;
                                            }
                                        }
                                    }
                                }
                                if (bFind)break;
                            }
                            if (!bFind){
                                var jsonNote = jsonDoc.notes;
                                for (var i=0;i<jsonNote.length;i++){
                                    var item = jsonNote[i];
                                    var szText = removeHtmlTags(item.noteDataDoc);
                                    if (szText.indexOf(mSearchKey) != -1){
                                        arraySearchs.push(p);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                p.doc = '';
            })

            //未补充的实际数量 ...
            setNoteSearchListCount(arraySearchs.length);

            var i = 4 - arraySearchs.length%4;
            for (var j = 0;j<i;j++){
                var item = {
                    id:'-1'
                }
                arraySearchs.push(item);
            }
            setIsSearching(false);
            setNoteSearchList(arraySearchs);
        })*/
    }


    let importConfig = {};
    if (!isWeb()) {
        importConfig = window.IPC.getConvertToken();
    }
    const editor = useEditor({
        injectCSS: true,
        extensions: [
            ...getTiptapExtension(null, '')
        ],
        parseOptions: {
            preserveWhitespace: 'full',
        },
    });

    let intervalImport: any;
    const key = 'importing';

    /** 导入Markdown */
    const importMarkdown = async () => {
        setIsOpenPopoverImport(false);

        ipcInvoke('import-markdown').then(async r => {
            if (!r) {
                return;
            }
            window.showProgress(t("Importing..."));

            // 展开所有文件（包括 zip 中的 md 文件）
            const allFiles: { path: string; content?: string; name?: string }[] = [];

            for (const filePath of r) {
                if (filePath.toLowerCase().endsWith(".zip")) {
                    // 处理 zip 文件
                    const mdFiles = await processZipImport(filePath);
                    for (const mdFile of mdFiles) {
                        allFiles.push({
                            path: filePath,
                            content: mdFile.content,
                            name: mdFile.name,
                        });
                    }
                } else {
                    // 普通 md 文件
                    allFiles.push({path: filePath});
                }
            }

            if (allFiles.length === 0) {
                window.closeProgress();
                return;
            }


            setProgress(0)

            let completeNum = 0
            let lock = false

            intervalImport = setInterval(async () => {
                if (completeNum == r.length) {
                    clearInterval(intervalImport);
                    window.closeProgress();

                    window.showMessageBox(t("Import complete"), t("YourCardsHasBeenImport"), '', t("View"), null, () => {
                        //转到library
                        postMessage(EVENT_SWITCH_HOME_LIST_MENU, {name: 'library'})
                    })

                    return;
                }
                if (!lock) {
                    lock = true;
                    editor?.commands.setContent('');

                    // 使用本地md解析器解析
                    const currentFile = allFiles[completeNum];
                    let fileContent: string;
                    let fileName: string;

                    if (currentFile.content  || allFiles[completeNum].path.toLowerCase().endsWith('.zip')) {
                        // 来自 zip 文件的内容
                        fileContent = currentFile.content;
                        fileName = currentFile.name || "untitled.md";
                    } else {
                        const fileInfo = window.IPC.getFileInfoByPath(allFiles[completeNum].path);
                        fileName = getFileNameWithoutExt(fileInfo.fileName);
                        fileContent = window.IPC.fsReadFileSync(allFiles[completeNum].path, 'utf-8');
                    }
                    // 解析节点内容
                    try {
                        handleImportMarkdown(editor, fileContent)
                        const html = imgServer.parserImgFromHtml(editor?.getHTML() as string);
                        await updateCard({
                            id: generateUUID2(),
                            type: 'card',
                            name: fileName,
                            doc: html
                        });
                    } catch (e) {

                    }

                    completeNum += 1
                    let processNow = Math.floor((completeNum / allFiles.length) * 100)
                    setProgress(processNow)
                    window.updateProgress(t("Importing") + '   ' + processNow + '%');
                    lock = false;
                }
            }, 200)
        })
    }

    /**
     * 项目里面是否包含tag
     * @param tag
     */
    const tagIsInProject = (tag: any) => {
        if (tag.value == FILTER_TAG_NO_TAGS || tag.id == MENU_SEPARATOR) {
            return true;
        }
        return mArrayNoteListCache.current.some(p => p.tags?.includes(tag.label));
    }

    const forThisLine = () => {
        let isTags = false;
        for (let i = 0; i < arrayTags.length; i++) {
            isTags = mArrayNoteListCache.current.some(p => p.tags?.includes(arrayTags[i].label));
            if (isTags) break;
        }
        return isTags;
    }

    /**
     * 是否有选择条目
     */
    const hasCheckSelectedOk = ()=>{
        const arraySelectedItem = getSelectedArray();
        if (arraySelectedItem.length == 0){
            message.info(t("PleaseSelected"));
            return null;
        }
        return arraySelectedItem;
    }

    /**
     * 管理标签
     */
    const managerTagsEvent = ()=>{
        const arraySelectItem = hasCheckSelectedOk();
        if (!arraySelectItem)return;
        mMapIdCheckRef.current = {};
        arraySelectItem.forEach(p=>{
            mMapIdCheckRef.current[p.id] = true;
        })
        mManagerTagsPageNum.current = mPageNum.current;
        dialogTagManagerRef.current?.onShowDialog(arraySelectItem);
    }

    /**
     * 多选删除
     * 删除选择的
     */
    const deleteSelectedEvent = ()=>{
        const arraySelectItem:any = hasCheckSelectedOk();
        if (!arraySelectItem)return;

        window.showMessageBox(t("Tips"),t("ConfirmDeleteSelectProject"),t("Cancel"),t("Delete"),null, async ()=>{
            for (let i=0;i<arraySelectItem.length;i++){
                arraySelectItem[i].isDeleted = 1;
                arraySelectItem[i].deleteTime = Date.now();
                arraySelectItem[i].isChecked = false;
            }
            batchUpdateProject(arraySelectItem).then(res=>{
                postMessage(EVENT_REFRESH_RECENTS);
                postMessage(EVENT_FAVIRIATE_CHANGE);
            });

            const arrayNewProjects = noteList.filter(p=>p.isDeleted != 1);
            arrayNewProjects.forEach(p=>{
                p.isChecked = false;
            })
            mMapIdCheckRef.current = {};
            setIsShowChecked(false);

            setTimeout(()=>{
                const div = document.getElementById('div-project-list-container');
                if (div?.scrollHeight > div?.clientHeight && arrayNewProjects.length > PAGE_SIZE){
                    //有滚动条。。。
                    setNoteList(arrayNewProjects);
                    setProjectCount(projectCount - arraySelectItem.length);
                }else{
                    //直接刷新..
                    refreshProjectList()
                }
            },100)

        })
    }

    /**
     * 取消选择，取消选中
     */
    const onExitChecked = ()=>{
        setIsShowChecked(false);
        //取消选择，取消选中
        const arrayNewNotes = [...noteList];
        arrayNewNotes.forEach(p=>{
            p.isChecked = false;
        })
        mMapIdCheckRef.current = {};
        setNoteList(arrayNewNotes);
    }

    /**
     * 渲染搜索后缀
     */
    const renderSuffix = () => {
        if (isSearching) {
            return <>
                <Spin indicator={<img className={'img-16 rotating-image'}
                                      src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
            </>
        } else {
            return <img className='img-mini-small-8 cursor-pointer'
                        style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit"}}
                        onClick={() => {
                            setSearchKey('');
                            mSearchKey = '';
                            mPageNum.current = 0;
                            refreshProjectList();
                        }}
                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        }
    }

    return (<div>
            <div id="divList" className={style.HomeIndexStyle}
                 style={{height: props.from == FROM_RIGHT_SIDE ? 'calc(100vh - 92px)' : '100vh',width:props.from == FROM_RIGHT_SIDE?'100%':`calc(100% - ${rightSliderWidth}px)`}}>
                {
                    props.from != FROM_RIGHT_SIDE &&
                    <div style={{display: 'flex', alignItems: 'center', minHeight: `${HEADER_HEIGHT}px`,
                        flexShrink:'0', gap: '12px 10px',flexWrap:'wrap',
                        background:'transparent',
                        marginRight: '-8px',padding:'6px 0px 6px 0px',marginBottom:'0px'}}>
                        <HomeNavigator margin={'0 0px 0 -4px'}/>
                        <Input prefix={<IconHomeSearch/>} suffix={renderSuffix()}
                               variant={"borderless"}
                               className={'input-border'}
                               style={{
                                   width: getSearchWidth(),
                                   height: '32px',
                                   marginLeft:'5px',
                                   // backgroundColor: 'var(--input-background-color)'
                               }}
                               placeholder={t("Search projects")} value={searchKey} onChange={onSearchChange}/>

                        {
                            //选择按钮--多选...
                            !isShowChecked &&
                            <div style={{padding: '0 0px', marginLeft: '10px', flexShrink: '0', marginRight: '16px',color:'var(--text-dark-gray-color)'}}
                                 className={'flex-center cursor-pointer default-font-size hovered-text-main-blue-color no-drag div-select'}
                                 onClick={() => {
                                     setIsShowChecked(!isShowChecked);
                                     let szSelectedTitle = t("Items selected").replace('{0}', '0');
                                     setShowCheckedTitle(szSelectedTitle)
                                 }}>{t("Select1")}</div>
                        }

                        <div style={{flexGrow: '1'}}></div>

                        {
                            props.from != FROM_RIGHT_SIDE && !isShowChecked &&
                            // region 右上角小按钮的
                            <>
                                <div
                                    className='button-max-height flex-center font-size-12 new-button no-drag'
                                    style={{
                                        height: '34px',
                                        border: '1px solid var(--input-border-color)',
                                        minWidth: '16px',
                                        width:'auto',
                                        padding: '0 16px',
                                        background:'var(--create-project-button-background)'
                                    }}
                                    onClick={() =>/*dialogNewProjectRef?.current.showNewProjectDialog()*/onNewProjectEvent("blank")}
                                    onMouseEnter={() => setIsNewProjectHover(true)}
                                    onMouseLeave={() => setIsNewProjectHover(false)}>
                                    <img className='img-16' src={getImagePathWithThemeSvg('create_project_1')}/>
                                    <span
                                        className='ml-8 font-family-regular'>{t("Create project")}</span>
                                </div>

                                <div className='button-max-height flex-center font-size-12 new-button no-drag'
                                     style={{
                                         height: '34px',
                                         border: '1px solid var(--input-border-color)',
                                         minWidth: '16px',
                                         width:'auto',
                                         padding: '0 16px',
                                         background:'var(--create-project-button-background)'
                                     }}
                                     onClick={async () => {
                                         //new card
                                         // Global.g_currentNoteData = {id: generateRandomPageKey()}
                                         // openEditor(Global.g_currentNoteData.id, false, false);
                                         if (!hasLicense() && !hasDesktopBaseLicense()) {
                                             const nCount = await getCardCount();
                                             if (nCount > MAX_CARD_COUNT && !isFreeCreateCardMode()) {
                                                 window.showMessageBox(t("Upgrade required"), t("YouNeedToUpgradeCreateCard"), t("Cancel"), t("Learn more"), null, () => {
                                                     if (isZh()) {
                                                         ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                                     } else {
                                                         ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                                     }
                                                 })
                                                 return;
                                             }
                                         }
                                         // window.navigateOrigin(getCardPath());
                                         window.showDialogCard({id: crypto.randomUUID()})
                                     }}
                                     onMouseEnter={() => setIsNewCardHover(true)}
                                     onMouseLeave={() => setIsNewCardHover(false)}>
                                    <img className='img-16'
                                         src={imgPathPerfix() + 'new_card_1.svg'}/>
                                    <span className='ml-8 font-family-regular'>{t("New card")}</span>
                                </div>
                                <Popover open={isOpenPopoverImport} arrow={false} trigger={['click']}
                                         placement={"bottomLeft"}
                                         onOpenChange={e => setIsOpenPopoverImport(e)} content={
                                    <div className={'default-font-family'}>
                                        <div className='flex hovered-present' style={{
                                            margin: '0 -12px',
                                            padding: '0 12px',
                                            minHeight: '46px',
                                            fontSize: '12px',
                                            alignItems: 'center',
                                            minWidth: noteItemWidth
                                        }} onClick={() => {
                                            setIsOpenPopoverImport(false);
                                            // if (isWeb()){
                                            //     window.showTipNotSupportWebOfflineVersion();
                                            //     return;
                                            // }
                                            importNote();
                                        }}>
                                            <div className='flex '>
                                                {/*<img className={'img-medium-small mt-4 ' + (isDarkMode() ? "filter-img-white" : "")}*/}
                                                {/*     src={imgPathPerfix() + 'present_board.png'}/>*/}
                                                <div className='flex-col ml-6'>
                                                    <span>{t("Import Projects")}</span>
                                                    <span datatype={'small-title'}>{t("ImportLocalCopy")}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='flex mt-8 hovered-present'
                                             style={{
                                                 margin: '10px -12px 0px -12px',
                                                 padding: '0 12px',
                                                 minHeight: '46px',
                                                 fontSize: '12px',
                                                 alignItems: 'center'
                                             }}
                                             onClick={async () => {
                                                 //markdown import.....
                                                 // importMarkdown();
                                                 setIsOpenPopoverImport(false);
                                                 window.importMarkdownMultiple();
                                             }}>
                                            <div className='flex'>
                                                {/*<img className={'img-medium-small mt-4 ' + (isDarkMode() ? "filter-img-white" : "")}*/}
                                                {/*     src={imgPathPerfix() + 'present_frame.png'}/>*/}
                                                <div className='flex-col ml-6'>
                                                    <span>{t("Import markdown")}</span>
                                                    <span datatype={'small-title'}>{t("ImportAPlainText1")}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }>
                                    <div
                                        className='button-max-height font-size-12 flex-center new-button no-drag'
                                        style={{
                                            height: '34px',
                                            border: '1px solid var(--input-border-color)',
                                            minWidth: '16px',
                                            width:'auto',
                                            padding: '0 16px',
                                            background:'var(--create-project-button-background)'
                                        }}
                                        onMouseEnter={() => setIsImportHover(true)}
                                        onMouseLeave={() => setIsImportHover(false)}>

                                        <img className='img-16'
                                             src={getImagePathWithTheme('import_1.svg')}/>
                                        <span className='ml-8 font-family-regular'>{t("Import")}</span>
                                    </div>
                                </Popover>


                                <Dropdown trigger={['click']} menu={{items: getLibraryMoreMenu()}}>
                                    <img className={'img-32 cursor-pointer'} style={{marginRight: '0px'}}
                                         src={getImagePathWithTheme('library_more_1.svg')}/>
                                </Dropdown>

                                {
                                    rightSliderWidth == 0 &&
                                    <img className='img-32 hovered-gray-radius'
                                         style={{marginLeft:'-2px'}}
                                         src={getImagePathWithTheme('home_slider_library.svg')} onClick={() => {
                                        window.openRightSlider(null, 'library');
                                    }}/>
                                }
                            </>
                            //endregion
                        }

                    </div>
                }

                {/*<div className={style.homeLine} style={{marginLeft:'-320px',marginRight:'-20px'}}/>*/}

                {/*新建项目，卡片，*/}
                {//也不要了。换成右上角 20260118
                    props.from != FROM_RIGHT_SIDE && false &&
                    // region 大按钮的。
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: columnTemplate,
                        alignItems: 'center',
                        gap: '0 32px',
                        marginTop: '0px'
                    }}>
                        <div
                            className='button-max-height flex-left-center font-size-12 new-button'
                            // style={{width: noteItemWidth}}
                            onClick={() =>/*dialogNewProjectRef?.current.showNewProjectDialog()*/onNewProjectEvent("blank")}
                            onMouseEnter={() => setIsNewProjectHover(true)}
                            onMouseLeave={() => setIsNewProjectHover(false)}>
                            <img className='img-26' src={imgPathPerfix() + 'home_new_project.svg'}/>
                            <span className='ml-12 font-family-medium medium-font-bold'>{t("Create project")}</span>
                            <span style={{display: 'block', flexGrow: '1'}}></span>
                            <img className='img-14'
                                 src={imgPathPerfix() + (isNewProjectHover ? 'add_blue.png' : (isDarkMode() ? 'add_number_white.png' : 'add_number.png'))}/>
                        </div>

                        <div className='button-max-height flex-center font-size-12 new-button'
                            // style={{marginLeft: '22px'}}
                             onClick={async () => {
                                 //new card
                                 // Global.g_currentNoteData = {id: generateRandomPageKey()}
                                 // openEditor(Global.g_currentNoteData.id, false, false);
                                 if (!hasLicense() && !hasDesktopBaseLicense()) {
                                     const nCount = await getCardCount();
                                     if (nCount > MAX_CARD_COUNT && !isFreeCreateCardMode()) {
                                         window.showMessageBox(t("Upgrade required"), t("YouNeedToUpgradeCreateCard"), t("Cancel"), t("Learn more"), null, () => {
                                             if (isZh()) {
                                                 ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                             } else {
                                                 ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                             }
                                         })
                                         return;
                                     }
                                 }
                                 // window.navigateOrigin(getCardPath());
                                 window.showDialogCard({id: crypto.randomUUID()})
                             }}
                             onMouseEnter={() => setIsNewCardHover(true)}
                             onMouseLeave={() => setIsNewCardHover(false)}>
                            <img className='img-26'
                                 src={imgPathPerfix() + 'home_new_card.svg'}/>
                            <span className='ml-12 font-family-medium medium-font-bold'>{t("New card")}</span>
                            <span style={{display: 'block', flexGrow: '1'}}></span>
                            <img className='img-14'
                                 src={imgPathPerfix() + (isNewCardHover ? 'add_blue.png' : (isDarkMode() ? 'add_number_white.png' : 'add_number.png'))}/>
                        </div>
                        <Popover open={isOpenPopoverImport} arrow={false} trigger={['click']} placement={"bottomLeft"}
                                 onOpenChange={e => setIsOpenPopoverImport(e)} content={
                            <div className={'default-font-family'}>
                                <div className='flex hovered-present' style={{
                                    margin: '0 -12px',
                                    padding: '0 12px',
                                    minHeight: '46px',
                                    fontSize: '12px',
                                    alignItems: 'center',
                                    minWidth: noteItemWidth
                                }} onClick={() => {
                                    setIsOpenPopoverImport(false);
                                    // if (isWeb()){
                                    //     window.showTipNotSupportWebOfflineVersion();
                                    //     return;
                                    // }
                                    importNote();
                                }}>
                                    <div className='flex '>
                                        {/*<img className={'img-medium-small mt-4 ' + (isDarkMode() ? "filter-img-white" : "")}*/}
                                        {/*     src={imgPathPerfix() + 'present_board.png'}/>*/}
                                        <div className='flex-col ml-6'>
                                            <span>{t("Import Projects")}</span>
                                            <span datatype={'small-title'}>{t("ImportLocalCopy")}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className='flex mt-8 hovered-present'
                                     style={{
                                         margin: '10px -12px 0px -12px',
                                         padding: '0 12px',
                                         minHeight: '46px',
                                         fontSize: '12px',
                                         alignItems: 'center'
                                     }}
                                     onClick={async () => {
                                         //markdown import.....
                                         // importMarkdown();
                                         setIsOpenPopoverImport(false);
                                         window.importMarkdownMultiple();
                                     }}>
                                    <div className='flex'>
                                        {/*<img className={'img-medium-small mt-4 ' + (isDarkMode() ? "filter-img-white" : "")}*/}
                                        {/*     src={imgPathPerfix() + 'present_frame.png'}/>*/}
                                        <div className='flex-col ml-6'>
                                            <span>{t("Import markdown")}</span>
                                            <span datatype={'small-title'}>{t("ImportAPlainText1")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }>
                            <div
                                className='button-max-height font-size-12 flex-center new-button'
                                // style={{marginLeft: '22px'}}
                                onMouseEnter={() => setIsImportHover(true)}
                                onMouseLeave={() => setIsImportHover(false)}>

                                <img className='img-26'
                                     src={imgPathPerfix() + 'home_new_import.svg'}/>
                                <span className='ml-12 font-family-medium medium-font-bold'>{t("Import")}</span>
                                <span style={{display: 'block', flexGrow: '1'}}></span>
                                <img className='img-16' style={{width: '12px', height: '7px'}}
                                     src={isImportHover ? (imgPathPerfix() + 'home_dropdown_blue.png') : getImagePathWithTheme('home_dropdown')}/>
                            </div>
                        </Popover>

                        <Button className='button-max-height button-border-gray-style font-size-12'
                                style={{
                                    marginLeft: '10px',
                                    display: mFolderId == '-2' ? 'inline' : 'none',
                                    height: '32px'
                                }}
                                onClick={createNewFolder}>{t("Create new folder")}</Button>
                    </div>
                    //endregion
                }


                {/*favorites*/}
                {
                    false &&
                    <div className={style.divFavor}>
                <span className='header-title' style={{
                    marginBottom: '6px',
                    marginTop: '16px',
                }}>{t("favor")}</span>
                    </div>
                }


                {/*文件夹标题名称*/}
                <span className='header-title font-family-semi-bold' style={{
                    marginBottom: '6px',
                    marginTop: '16px',
                    display: t("Folders") === folderName ? 'inline' : 'none'
                }}>{folderName}</span>
                {/*<Link to='/newNote'>*/}
                {/*    <Button type="primary" icon={<FileAddOutlined/>}>新建</Button>*/}
                {/*</Link>*/}
                {/*<Link to='/draw'>*/}
                {/*    <Button type="primary" style={{marginLeft: '1px'}}>{t("New canvas")}</Button>*/}
                {/*</Link>*/}


                {/************文件夹******************/}
                {
                    //region 不用.
                    false &&
                    <div style={{
                        display: (locationParams.state?.usr?.folderId === '-2' && arrayFolders.length > 0) ? 'inherit' : 'none',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        flexShrink: '0',
                        maxHeight: '40%',
                        paddingTop: '12px'
                    }}>
                        <List
                            grid={{gutter: 16, column: 4}}
                            dataSource={arrayFolders}
                            renderItem={(item, index) => (
                                <List.Item data-index={index} onMouseEnter={onFolderMouseEnter}
                                           onMouseLeave={onFolderMouseLeave} onClick={onFolderDoubleClick}>
                                    <Dropdown overlayClassName='default-dropdown-style'
                                              menu={{items: ARRAY_FOLDER_MORE, onClick: onFolderMoreClickEvent}}
                                              trigger={['contextMenu']}>
                                        <div className='hovered' style={{
                                            display: "flex",
                                            backgroundColor: 'var(--item-background-color)',
                                            height: '52px',
                                            alignItems: 'center',
                                            padding: '0 16px',
                                            overflow: 'hidden',
                                            borderRadius: '10px'
                                        }}>
                                            <img className='img-medium' src={imgPathPerfix() + "project_folder.png"}/>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: 'column',
                                                marginLeft: '12px',
                                                flexGrow: '1',
                                                marginRight: '12px',
                                                overflow: 'hidden'
                                            }}>
                                            <span style={{
                                                width: 'calc(100% - 10px)',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap'
                                            }}>{item.name}</span>
                                                <span style={{
                                                    color: 'var(--tab-text-color)',
                                                    fontSize: '12px'
                                                }}>{(item.projectCount || 0) + " " + t("Projects")}</span>
                                            </div>
                                            {/*<Dropdown menu={{items:ARRAY_FOLDER_MORE,onClick:onFolderMoreClickEvent}} trigger={['click']}>*/}
                                            {/*    <MoreOutlined style={{flexShrink:'1',marginLeft:'12px',visibility:item.showMore?'visible':'hidden'}}/>*/}
                                            {/*</Dropdown>*/}
                                        </div>
                                    </Dropdown>
                                </List.Item>
                            )}
                        />
                    </div>
                    //endregion
                }


                {/*标题名称*/}
                {
                    props.from != FROM_RIGHT_SIDE &&
                    <>
                        {//这里有正常的标题和取消选择的操作
                            isShowChecked? <div className={'flex-row-vertical-center'} style={{marginTop: '16px', marginBottom: '4px',height:'32px'}}>
                                    <span className='header-title font-family-semi-bold'
                                          style={{marginBottom: '1px'}}>{showCheckedTitle}</span>
                                    <span className={'cursor-pointer button-border-gray-style flex-center ml-16'}
                                          style={{height: '32px', marginLeft: '22px', padding: BUTTON_PADDING}}
                                          onClick={() => {
                                              onExitChecked();
                                          }}>{t("Cancel")}</span>
                                    <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                                        {/*manage tags*/}
                                        <div style={{marginLeft: '16px', height: '32px', padding: BUTTON_PADDING}}
                                             onClick={() => {
                                                 managerTagsEvent();
                                             }}
                                             className={'button-border-gray-style flex-center  font-family-regular'}>{t("Manage tags")}</div>
                                        <div style={{
                                            marginLeft: '16px', height: '32px', padding: BUTTON_PADDING,
                                            background: 'transparent',
                                            color: '#DC463F',
                                            border: '1px solid #DC463F'
                                        }} onClick={() => {
                                            deleteSelectedEvent();
                                        }}
                                             className={'button-border-danger-style flex-center'}>{t("Delete")}</div>
                                    </div>
                                </div> :
                                <div className={'flex-row-vertical-center'}
                                     style={{marginTop: '16px', marginBottom: '4px', minHeight: '32px'}}>
                                <span className='header-title font-family-semi-bold' style={{
                                    display: t("Folders") != folderName ? 'inline' : 'none'
                                }}>{isShowHiddenProjects?t('Hidden Projects'):folderName}</span>
                                    {
                                        projectCount > 0 &&
                                        <span style={{
                                            marginLeft: '6px',
                                            background: 'var(--project-count-backround-color)',
                                            border: '0px solid var(--project-count-border-color)',
                                        borderRadius: '20px',
                                        padding: '1.2px 10px',
                                        fontSize: '13px',
                                        color: 'var(--project-count-text-color)'
                                    }}>{projectCount}</span>
                                }

                                {
                                    //当显示隐藏的项目时候，显示取消按钮
                                    isShowHiddenProjects &&
                                    <span className={'cursor-pointer button-border-gray-style flex-center ml-16'}
                                          style={{
                                              height: '32px',
                                              marginLeft: '22px',
                                              padding: BUTTON_PADDING,
                                              minWidth: '76px'
                                          }} onClick={() => {
                                        //退出隐藏状态
                                        localStorage.setItem(KEY_SHOW_HIDIN_PROJECTS, 'false');
                                        setIsShowHiddenProjects(false);
                                        refreshProjectList();
                                    }}>{t("Cancel")}</span>
                                }
                            </div>
                        }
                    </>
                }


                {/*排序*/}
                {
                    props.from != FROM_RIGHT_SIDE &&
                    <div className={style.title}
                         style={{marginTop: t("Folder") != folderName ? '10px' : '5px', marginBottom: '16px'}}>
                        {/*<div onClick={onExpandOrCollapseNote} className='cursor-pointer' style={{*/}
                        {/*    display: 'flex',*/}
                        {/*    alignItems: 'center',*/}
                        {/*    visibility: mFolderId === '-2' ? 'visible' : 'hidden'*/}
                        {/*}}>*/}
                        {/*    <img className='img-mini-small' src={imgPathPerfix() + "drop_down_gray.png"} style={{*/}
                        {/*        transform: isNoteListVisible ? 'rotate(0deg)' : 'rotate(270deg)',*/}
                        {/*        width: '12px',*/}
                        {/*        height: '12px'*/}
                        {/*    }} rotate={isNoteListVisible ? '0' : '90'}/>*/}
                        {/*    <span className='text-color-a'*/}
                        {/*          style={{marginLeft: '8px'}}>{t("Projects") + "(" + noteList.filter(p => p.id != '-1').length + ")"}</span>*/}
                        {/*</div>*/}

                        <ProjectTab ref={mProjectTabRef} isShowChecked={isShowChecked} onActiveItem={(item) => {
                            setActiveTabItem(item);
                            mActiveTabItemRef.current = item;
                            updateNoteList(null, false, 0);
                        }}/>

                        <div style={{flexGrow: '1'}}></div>

                        <div className={style.right}>
                            {
                                selectTag &&
                                <div className={'flex-row-vertical-center'} style={{
                                    background: 'var(--draw-tool-bar-selected-color)',
                                    borderRadius: '100px',
                                    height: '32px',
                                    padding: '0 10px'
                                }}>
                                    <span>{selectTag.label}</span>
                                    <img className={'img-14 cursor-pointer ml-2'}
                                         src={getImagePathWithTheme('tag_close')} onClick={() => {
                                        setSelectTag(null);
                                        mSelectTag.current = '';
                                        updateNoteList(null, false, 0);
                                    }}/>
                                </div>

                            }

                            <Dropdown overlayClassName='default-dropdown-style' overlayStyle={{minWidth: '232px'}}
                                      trigger={['click']}
                                      onOpenChange={(e) => {
                                          setIsTagFilterOpened(e);
                                      }} open={isTagFilterOpened} dropdownRender={(menu) => {
                                return (
                                    <>
                                        <div className={'font-family-regular'} style={{
                                            overflowX: 'hidden',
                                            maxHeight: '320px',
                                            overflowY: 'auto',
                                            display: 'flex',
                                            borderRadius: '8px',
                                            padding: '6px',
                                            boxShadow: 'var(--dialog-box-shadow)',
                                            flexDirection: 'column',
                                            background: 'var(--dialog-dialog-background-color-2c)'
                                        }}>
                                            {
                                                arrayTags.map(p =>
                                                    tagIsInProject(p) ?
                                                        <>
                                                            {
                                                                forThisLine() &&
                                                                p.id == MENU_SEPARATOR &&
                                                                <div key={p.value} className={'line'}
                                                                     style={{margin: '4px -6px'}}></div>
                                                            }
                                                            {
                                                                p.id !== MENU_SEPARATOR &&
                                                                <div key={p.value} className={'dropdown-item'}
                                                                     onClick={() => {
                                                                         setIsTagFilterOpened(false);
                                                                         setSelectTag(p);//当前选择的标签

                                                                         if (p.value == FILTER_TAG_NO_TAGS) {
                                                                             mSelectTag.current = FILTER_TAG_NO_TAGS + '-----';//没有tag的标题
                                                                         } else {
                                                                             mSelectTag.current = p.label;
                                                                         }
                                                                         //更新列表...
                                                                         updateNoteList(null, false, -1);
                                                                     }}>
                                                    <span className={'span-single-line'} style={{
                                                        paddingLeft: '12px',
                                                        paddingRight: '12px'
                                                    }}>{(p.value == FILTER_TAG_NO_TAGS ? '' : '#') + p.label}</span>
                                                                </div>
                                                            }
                                                        </> : <></>
                                                )
                                            }
                                            {
                                                arrayTags.length == 0 && //默认有个no tags 和横线....
                                                <span style={{margin: '6px 12px 0px 12px'}}>{t("No tags yet")}</span>
                                            }

                                            <div style={{flexGrow: '1'}}></div>

                                            {
                                                props.from != FROM_LIBRARY &&
                                                <>
                                                    <div className={'line'} style={{
                                                        margin: '4px -6px',
                                                        // background: 'var(--vertical-line-color)',
                                                        flexShrink: '0'
                                                    }}></div>
                                                    {/*添加manager*/}
                                                    <div className={'flex-row-vertical-center cursor-pointer'}
                                                         style={{padding: '6px 12px'}}
                                                         onClick={() => {
                                                             // dialogAllTagManagerRef.current?.onShowDialog();
                                                             postMessage(EVENT_SWITCH_HOME_LIST_MENU, {name: 'tags'});
                                                         }}>
                                                        <img className={'img-16'}
                                                             src={getImagePathWithTheme('go_to_tags')}/>
                                                        <span className={'ml-8'}
                                                              style={{marginTop: '1px'}}>{t("Go to tags")}</span>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </>
                                )
                            }}>
                                <Tooltip arrow={false} title={t("Tags")}>
                                    <Button type={"text"} className="small-button hovered" style={{marginLeft: '2px'}} onClick={(e)=>{
                                        if (isShowChecked){
                                            e.preventDefault();
                                            e.stopPropagation();
                                            message.info(t('PleaseExitSelectStatus'));
                                            return;
                                        }
                                        if (isShowHiddenProjects) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            message.info(t('PleaseExitCurStatus'));
                                            return;
                                        }
                                    }}>
                                        <img className="img-16" src={getImagePathWithTheme('project_filter_tag.svg')} onClick={(e)=>{
                                            if (isShowChecked){
                                                e.preventDefault();
                                                e.stopPropagation();
                                                message.info(t('PleaseExitSelectStatus'));
                                                return;
                                            }
                                            if (isShowHiddenProjects) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                message.info(t('PleaseExitCurStatus'));
                                                return;
                                            }
                                        }}/>
                                    </Button>
                                </Tooltip>

                            </Dropdown>

                            <Dropdown overlayClassName='default-dropdown-style' overlayStyle={{minWidth: '232px'}}
                                      menu={{items: sortMenu, onClick: onSortMenuClick}} trigger={['click']}
                                      onOpenChange={handleSortOpenChange} open={sortMenuOpen}>
                                {/*<span className='hovered' onClick={(e) => e.preventDefault()}>*/}
                                {/*    <div className='flex-row-vertical-center' style={{height: '28px', padding: '0px 8px'}}>*/}
                                {/*        <span className='text-color'>{sortTypeDesc}</span>*/}
                                {/*        <img className='img-mini-small ml-8' style={{width: '10px', height: '9px'}}*/}
                                {/*             src={getImagePathWithTheme("drop_down_home")}/>*/}
                                {/*    </div>*/}
                                {/*</span>*/}
                                <Tooltip arrow={false} title={t("Sort")}>
                                    <Button type={"text"} className="small-button hovered" style={{marginLeft: '2px'}} onClick={(e)=>{
                                        if (isShowChecked){
                                            e.preventDefault();
                                            e.stopPropagation();
                                            message.info(t('PleaseExitSelectStatus'));
                                            return;
                                        }
                                        if (isShowHiddenProjects) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            message.info(t('PleaseExitCurStatus'));
                                            return;
                                        }
                                    }}>
                                        <img className="img-16" src={getImagePathWithTheme('project_sort.svg')} onClick={(e)=>{
                                            if (isShowChecked){
                                                e.preventDefault();
                                                e.stopPropagation();
                                                message.info(t('PleaseExitSelectStatus'));
                                                return;
                                            }
                                            if (isShowHiddenProjects) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                message.info(t('PleaseExitCurStatus'));
                                                return;
                                            }
                                        }}/>
                                    </Button>
                                </Tooltip>
                            </Dropdown>
                            <Tooltip arrow={false}
                                     title={viewStyle == VIEW_STYLE.VIEW_STYLE_GRID ? t("Grid view") : t("List view")}>
                                <Button type={"text"} className="small-button hovered" style={{marginLeft: '2px'}}
                                        onClick={(e) => {
                                            if (isShowChecked){
                                                e.preventDefault();
                                                e.stopPropagation();
                                                message.info(t('PleaseExitSelectStatus'));
                                                return;
                                            }
                                            if (isShowHiddenProjects) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                message.info(t('PleaseExitCurStatus'));
                                                return;
                                            }
                                            btnViewStyleClicked()
                                        }}>
                                    <img className="img-16"
                                         src={getImagePathWithTheme(viewStyle == VIEW_STYLE.VIEW_STYLE_GRID ? 'project_grid_view.svg' : 'project_list_view.svg')} onClick={(e)=>{
                                        if (isShowChecked){
                                            e.preventDefault();
                                            e.stopPropagation();
                                            message.info(t('PleaseExitSelectStatus'));
                                            return;
                                        }
                                        if (isShowHiddenProjects) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            message.info(t('PleaseExitCurStatus'));
                                            return;
                                        }
                                    }}/>
                                </Button>
                            </Tooltip>
                            {/*<Button type={"text"} className="small-button hovered" style={{marginLeft: '12px'}}*/}
                            {/*        onClick={() => btnViewStyleClicked(VIEW_STYLE.VIEW_STYLE_LIST)}>*/}
                            {/*    <img className="img-mini-small-18" src={getImagePathWithTheme('list')}/>*/}
                            {/*</Button>*/}
                        </div>
                    </div>
                }


                <div id={'div-project-list-container'} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: '1',
                    overflowY: 'auto',
                    margin: '0 -20px',
                    paddingLeft: '4px',
                    position:'relative'
                }} onScroll={(e) => {
                    if (searchKey) return;//带搜索的不分页.
                    let he = e.currentTarget.scrollHeight - e.currentTarget.clientHeight - e.currentTarget.scrollTop
                    // console.log(he);
                    if (e.currentTarget.scrollTop != 0 && he > -10 && he < 10) {
                        updateNoteList(null, false, mPageNum.current + 1);
                    }
                }}>
                    <div className={'div-onmousedown-mouseup-mousemove'} style={{display: (isNoteListVisible || mFolderId != '-2') ? 'inline' : 'none',height:'100%',width:'100%'}} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onMouseMove={onMouseMove}>
                        {renderListViewTitle()}
                        {renderNoteList()}
                    </div>
                </div>


                {/*搜索结果*/}
                <div className={style.searchContainer} style={{
                    display: isStringNullOrEmpty(searchKey) ? 'none' : 'none',
                    backgroundColor: props.from == FROM_RIGHT_SIDE ? 'var(--background-color)' : 'var(--background-color)',
                    height: '100%',
                    zIndex: '9999',
                    top: props.from == FROM_RIGHT_SIDE ? '-16px' : '40px'
                }}>
                    <span className='header-title ml-6 font-family-semi-bold'>{t("Search Results")}</span>

                    <div style={{height: 'calc(100% - 90px)', marginTop: '6px'}}>
                        <div className={'flex-column-center'}
                             style={{
                                 display: noteSearchListCount === 0 ? 'flex' : 'none',
                                 zIndex: '100',
                                 marginTop: '36px'
                             }}>
                            <img style={{height: '294px', width: '294px'}}
                                 src={getImagePathWithTheme("search_no_result")}></img>
                            <span className='description-color ml-8' style={{
                                textAlign: 'center',
                                lineHeight: '22px'
                            }}>{t("No results found").replace('%s', searchKey)}</span>
                        </div>
                        <div style={{height: '100%', overflow: 'auto', margin: '0 -16px', padding: '0 20px'}}>
                            {renderSearchNoteList()}
                        </div>
                    </div>

                    <Spin indicator={IconIndicatorBlue}
                          style={{position: "absolute", left: '50%', top: 'calc(50% - 100px)'}} spinning={isSearching}>

                    </Spin>

                </div>

                <DialogNewProject ref={dialogNewProjectRef}
                                  onItemClicked={onNewProjectEvent}/>

                <DialogTemplate ref={dialogTemplateRef} onTemplateItemClick={onTemplateItemClick}/>

                <DialogNewFolder ref={dialogNewFolderRef} onOkEvent={onFolderUpdateOk}/>

                <DialogMovetoFolder ref={dialogMovetoFolderRef}/>

                <DialogImport ref={dialogImportRef} onImportNoteData={onImportNote} onStartImport={() => {
                    window.showIndicator();
                }}/>

                <DialogMessageBox ref={dialogMessageBoxRef}/>

                <DialogTagManager ref={dialogTagManagerRef} from={"project"}
                                  onDismissCallback={(isTagChange: boolean) => {
                                      if (isTagChange) {
                                          //标签更改了，需要刷新数据....
                                          updateNoteList(null,false,0);
                                          updateTagList();
                                      }
                                  }}/>

                <DialogChooseThumb ref={dialogChooseThumbRef}/>

                {
                    noteList.length == 0 &&
                    <span style={{position:'absolute',left:'50%',top:'50%',transform:'translate(-50%,-50%)',color:'var(--color-9A9A9A)'}}>{getEmptyTips()}</span>
                }

            </div>


            {
                props.from != FROM_RIGHT_SIDE &&
                <div className={'right-slider-hold-width'} style={{width: `${rightSliderWidth}px`, flexShrink: '0'}}/>
            }
        </div>
    )
})

export default HomeIndex


























